import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td
} from '@chakra-ui/react';
import { api } from '../../../services/api';
import { useQuery } from 'react-query';
import { formatPrice } from '../../../utils/formatPrice';

async function getRevenue() {
  const { data } = await api.get('/site/v2/controle-crm/busca-info-empresas');

  data.comercio_brindes = formatPrice(data.comercio_brindes);
  data.dt_brindes = formatPrice(data.dt_brindes);

  return data;
}

export function ModalRevenue() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { data: revenues } = useQuery({
    queryKey: 'revenue',
    queryFn: getRevenue,
    staleTime: 1000 * 60 * 10, // 10 minutes
    refetchOnWindowFocus: false
  });

  return (
    <>
      <Button onClick={onOpen}>+ Faturamentos por empresa</Button>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Faturamentos por empresa</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Table
              sx={{
                borderCollapse: 'collapse'
              }}
              size="sm"
              colorScheme="gray"
              borderWidth="1px"
              //boder collapse="collapse"
              borderRadius="md">
              <Thead>
                <Tr>
                  <Th textAlign="center" border="1px solid #E2E8F0">
                    Innovation Brindes
                  </Th>
                  <Th textAlign="center">DT Brindes</Th>
                </Tr>
              </Thead>
              <Tbody>
                <Tr>
                  <Td textAlign="center" border="1px solid #E2E8F0">
                    {revenues?.comercio_brindes}
                  </Td>
                  <Td textAlign="center">{revenues?.dt_brindes}</Td>
                </Tr>
              </Tbody>
            </Table>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
